// extracted by mini-css-extract-plugin
module.exports = {"taskGroup":"taskGroup_taskGroup__M6cZ5","taskGroup__content":"taskGroup_taskGroup__content__2wfZp","taskGroup__list":"taskGroup_taskGroup__list__3STJr"};